import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home/Home.vue";
import Index from "../views/Index";
import NotFound from "../views/404.vue";

Vue.use(VueRouter);


const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
          title: "宇起数字",
          description: "宇起数字，专注智能指纹密码器、智能指纹柜锁、售后服务。"
        }
      },
      {
        path: "/platform",
        name: "Platform",
        component: () => import("../views/Platform/platform.vue"),
        meta: {
          title: "平台介绍 - 宇起数字",
          description: "宇起数字平台介绍，智能指纹密码器、智能指纹柜锁等产品平台信息。"
        }
      },
      {
        path: "/platform2",
        name: "Platform2",
        component: () => import("../views/Platform/platform2.vue"),
        meta: {
          title: "数据安全 - 宇起数字",
          description: "宇起数字数据安全解决方案。"
        }
      },
      {
        path: "/chrome",
        name: "Chrome",
        component: () => import("../components/AboutUs/InPlug/chrome.vue"),
        meta: {
          title: "Chrome插件 - 宇起数字",
          description: "宇起数字Chrome插件下载与使用说明。"
        }
      },
      {
        path: "/household",
        name: "Household",
        component: () => import("../components/Scene/household.vue"),
        meta: {
          title: "家用场景 - 宇起数字",
          description: "宇起数字家用智能锁应用场景。"
        }
      },
      {
        path: "/mores",
        name: "More",
        component: () => import("../components/Scene/more.vue"),
        meta: {
          title: "更多场景 - 宇起数字",
          description: "宇起数字更多智能锁应用场景。"
        }
      },
      {
        path: "/work",
        name: "Work",
        component: () => import("../components/Scene/work.vue"),
        meta: {
          title: "办公场景 - 宇起数字",
          description: "宇起数字办公智能锁应用场景。"
        }
      },
      {
        path: "/join",
        name: "Join",
        component: () => import("../views/Join/index.vue"),
        meta: {
          title: "招商加盟 - 宇起数字",
          description: "宇起数字招商加盟信息。"
        }
      },
      {
        path: "/serve",
        name: "Serve",
        component: () => import("../views/Serve/index.vue"),
        meta: {
          title: "售后服务 - 宇起数字",
          description: "宇起数字售后服务，7天无理由退货，30天免费换货，客户回访等服务内容。"
        },
        children: [
          {
            path: "/",
            name: "sale",
            component: () => import("../components/ServeChild/sale/index.vue"),
          },
          {
            path: "issue",
            name: "issue",
            component: () => import("../components/ServeChild/issue/index.vue"),
            meta: {
              title: "常见问题 - 宇起数字",
              description: "宇起数字常见问题解答。"
            }
          },
          {
            path: "issueAbout",
            name: "issueAbout",
            component: () => import("../components/ServeChild/issue/issueAbout.vue"),
            meta: {
              title: "问题详情 - 宇起数字",
              description: "宇起数字常见问题详情。"
            }
          },
          {
            path: "specification",
            name: "specification",
            component: () => import("../components/ServeChild/specification/index.vue"),
            meta: {
              title: "产品说明书 - 宇起数字",
              description: "宇起数字产品说明书下载。"
            }
          },
          {
            path: "instructions",
            name: "instructions",
            component: () => import("../components/ServeChild/instructions/index.vue"),
            meta: {
              title: "产品安装视频 - 宇起数字",
              description: "宇起数字产品安装视频。"
            }
          },
        ],
      },
      
      {
        path: "Y02B",
        name: "Y02B",
        component: () => import("../components/Shop/Y02B.vue"),
        meta: {
          title: "Y02B产品详情 - 宇起数字",
          description: "宇起数字Y02B智能指纹柜锁产品详情。"
        }
      },
      {
        path: "Y02L",
        name: "Y02L",
        component: () => import("../components/Shop/Y02L.vue"),
        meta: {
          title: "Y02L产品详情 - 宇起数字",
          description: "宇起数字Y02L智能指纹柜锁产品详情。"
        }
      },
      {
        path: "Y03B",
        name: "Y03B",
        component: () => import("../components/Shop/Y03B.vue"),
        meta: {
          title: "Y03B产品详情 - 宇起数字",
          description: "宇起数字Y03B智能指纹柜锁产品详情。"
        }
      },
      {
        path: "Y03L",
        name: "Y03L",
        component: () => import("../components/Shop/Y03L.vue"),
        meta: {
          title: "Y03L产品详情 - 宇起数字",
          description: "宇起数字Y03L智能指纹柜锁产品详情。"
        }
      },
      {
        path: "Y01P",
        name: "Y01P",
        component: () => import("../components/Shop/Y01P.vue"),
        meta: {
          title: "Y01P产品详情 - 宇起数字",
          description: "宇起数字Y01P智能指纹密码器产品详情。"
        }
      },
      {
        path: "/synopsis",
        name: "Synopsis",
        component: () => import("../components/AboutUs/Synopsis/index.vue"),
        meta: {
          title: "公司简介 - 宇起数字",
          description: "宇起数字公司简介、企业文化等信息。"
        }
      },
      {
        path: "/inPlug",
        name: "InPlug",
        component: () => import("../components/AboutUs/InPlug/index.vue"),
        meta: {
          title: "插件下载 - 宇起数字",
          description: "宇起数字插件下载与使用说明。"
        }
      },
      
      {
        path: "/new",
        name: "New",
        component: () => import("../components/AboutUs/New/index.vue"),
        meta: {
          title: "新闻动态 - 宇起数字",
          description: "宇起数字新闻动态、行业资讯。"
        },
        children: [],
      },
      {
        path: "/particular",
        name: "Particular",
        component: () => import("../components/AboutUs/Particular/index.vue"),
        meta: {
          title: "产品详情 - 宇起数字",
          description: "宇起数字产品详细信息。"
        }
      },
      {
        path: "newAbout",
        name: "newAbout",
        component: () => import("../components/AboutUs/New/newAbout.vue"),
        meta: {
          title: "新闻详情 - 宇起数字",
          description: "宇起数字新闻详情。"
        }
      },
      {
        path: "/recruit",
        name: "Recruit",
        component: () => import("../components/AboutUs/Recruit/index.vue"),
        meta: {
          title: "人才招聘 - 宇起数字",
          description: "宇起数字人才招聘信息。"
        }
      },
      {
        path: "/relation",
        name: "Relation",
        component: () => import("../components/AboutUs/Relation/index.vue"),
        meta: {
          title: "联系我们 - 宇起数字",
          description: "宇起数字联系方式、售后服务电话等信息。"
        }
      },
   
    ],
    
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {
      title: "关于我们 - 宇起数字",
      description: "宇起数字公司介绍、发展历程、联系方式等信息。"
    }
  },
  {
    path: "/helloWorld",
    name: "HelloWorld",
    component: () => import("../components/HelloWorld.vue"),
    meta: {
      title: "HelloWorld - 宇起数字",
      description: "宇起数字HelloWorld测试页面。"
    }
  },
  {
    path: "/serve2",
    name: "Serve2",
    component: () => import("../views/Serve/serve2.vue"),
    meta: {
      title: "支持列表 - 宇起数字",
      description: "支持列表。"
    }
  },
  // 404 page must be placed at the end !!!
  {
    path: "*",
    component: NotFound,
    meta: {
      title: "404 - 页面未找到",
      description: "您访问的页面不存在。"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果之前有保存滚动位置，则恢复到之前保存的位置
      return savedPosition;
    } else {
      // 否则，默认滚动到页面顶部
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  if (true) next();
  else next();
});

export default router;
